export default {
    // backgroundColor: 'white',

    tooltip : {
        trigger: 'item',
        formatter: '{b}'
    },
    legend: {
        orient: 'vertical',
        x: 'left',
        y: 10,
        data: []
    },
    series : [
        {
            name: 'Sales',
            type: 'pie',
            radius : [50, 100],
            center: ['50%', '70%'],
            data: [],
            avoidLabelOverlap: false,
            // roseType: 'area',
            label: {
                normal: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    show: false,
                    textStyle: {
                        fontSize: '30',
                        fontWeight: 'bold'
                    }
                }
            },
            labelLine: {
                normal: {
                    show: false
                }
            },
            animationType: 'scale',
            animationEasing: 'elasticOut',
            animationDelay: function (idx: any) {
                return Math.random() * 200;
            }
        }
    ]
};
